<template>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">

                <div class=" container-lg  base-header__container ">
                    <div class="inner ml-lg-5 d-flex justify-content-between align-items-center">
                        <h2 class="base-header__title mob d-block d-lg-none">
                            Мишљења, модели, литература
                        </h2>
                        <ul class="nav ">
                            <li class="nav-item">
                                <router-link class="nav-link" to="/mml-latest">Најновије</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link base-sub-page-link" to="/mml-standard-search">Стандардна претрага</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link base-sub-page-link" to="/mml-opinion-search">Мишљења и други акти</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link base-sub-page-link" to="/mml-qa-search">Питања и одговори</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link base-sub-page-link" to="/mml-model-search">Модели уговора и других аката</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link base-sub-page-link" to="/mml-literature-search">Литература</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link " :to="{ path: '/mml-static', query: { page: 'help' ,code:'LSD'}}">
                                    Помоћ
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link " :to="{ path: '/mml-static', query: { page: 'contact' ,code:'LSD'}}">
                                    Контакт
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link " :to="{ path: '/mml-static', query: { page: 'impresum' ,code:'LSD'}}">
                                    Импресум
                                </router-link>
                            </li>
                        </ul>
                        <h1 class="base-header__title d-none d-lg-block">
                            Мишљења, модели, литература
                        </h1>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
    export default {
        name: "MmlBaseHeaderSec"
    }
</script>

<style scoped>

</style>
